import {v4 as uuidv4} from 'uuid';

import {assert} from 'Asserts';
import APIUtil from 'util/APIUtil';

import {
  TaskSchemaNodeSection,
  TASK_SCHEMA_NODE_SECTION_PREFIX,
  NODE_SECTION_PREFIX_TO_TASK_SCHEMA_NODE_SECTION,
  ProcessFlowchartEdgeType,
} from './TransitionModalWithFlowchartEditorConstants';

export const NODE_IDENTIFIER_PREFIX = 'node';
export const FIELD_IDENTIFIER_PREFIX = 'field';

export function getTaskSchemaIdFromNodeIdentifier(nodeIdentifier: string): string {
  const identifierParts = nodeIdentifier.split(':');
  assert(identifierParts.length === 3, `Invalid node identifier: ${nodeIdentifier}`);
  const taskSchemaId = identifierParts[1];
  assert(APIUtil.isProcessTaskSchema(taskSchemaId), `Invalid task schema id: ${taskSchemaId}`);
  return taskSchemaId;
}

export function generateTaskSchemaNodeIdentifier(schemaInfo: {taskSchema: {id: string}}): string {
  const {taskSchema} = schemaInfo;
  const {id} = taskSchema;
  // Task schemas can be repeated in a flowchart, add a unique identifier to distinguish nodes
  const hash = uuidv4();
  return `${NODE_IDENTIFIER_PREFIX}:${id}:${hash}`;
}

export function getSchemaFieldInfoFromHandle(handleId: string): {
  fieldId: string;
  taskSchemaNodeSection: TaskSchemaNodeSection;
} {
  const identifierParts = handleId.split(':');
  assert(identifierParts.length === 3, `Invalid handleId: ${handleId}`);
  const fieldContents = identifierParts[2];
  const fieldId = fieldContents.split('-')[0];
  const taskSchemaNodeSection = NODE_SECTION_PREFIX_TO_TASK_SCHEMA_NODE_SECTION[identifierParts[1]];
  assert(APIUtil.isSchemaField(fieldId), `Invalid fieldId: ${fieldId}`);
  return {fieldId, taskSchemaNodeSection};
}

export function generateTaskSchemaFieldRowIdentifier(
  fieldId: string,
  taskSchemaNodeSection: TaskSchemaNodeSection
): string {
  return `${FIELD_IDENTIFIER_PREFIX}:${TASK_SCHEMA_NODE_SECTION_PREFIX[taskSchemaNodeSection]}:${fieldId}`;
}

export function makeDataFlowEdgeHandle(
  fieldId: string,
  taskSchemaNodeSection: TaskSchemaNodeSection,
  handleType: 'source' | 'target'
): string {
  return `${generateTaskSchemaFieldRowIdentifier(fieldId, taskSchemaNodeSection)}-${handleType}`;
}

export function getEdgeTypeFromHandleId(handleId: string): ProcessFlowchartEdgeType {
  if (handleId.startsWith(NODE_IDENTIFIER_PREFIX)) {
    return ProcessFlowchartEdgeType.CONTROL_FLOW;
  }
  if (handleId.startsWith(FIELD_IDENTIFIER_PREFIX)) {
    return ProcessFlowchartEdgeType.DATA_FLOW;
  }
  throw new Error(`Invalid handleId: ${handleId}`);
}
